import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { cartLineCardExpandedStyles } from "@insite/content-library/Components/CartLineCardExpanded";

import { css } from "styled-components";

cartLineCardExpandedStyles.extendedUnitNetPrice = mergeToNew(cartLineCardExpandedStyles.extendedUnitNetPrice, {
    text: {
        weight: 700,
        color: "text.accent",
    },
});

cartLineCardExpandedStyles.priceGridItem = mergeToNew(cartLineCardExpandedStyles.priceGridItem, {
    text: {
        weight: 700,
        color: "text.accent",
    },
});

cartLineCardExpandedStyles.extendedUnitNetPriceGridItem = mergeToNew(
    cartLineCardExpandedStyles.extendedUnitNetPriceGridItem,
    {
        width: [6, 6, 4, 4, 4],
    },
);

cartLineCardExpandedStyles.quantityGridItem = mergeToNew(cartLineCardExpandedStyles.quantityGridItem, {
    width: [6, 6, 3, 3, 3],
});
